// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.WalletBackendSharedDataTooLargeException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap

fun WalletBackendSharedDataTooLargeException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Ch4nNnd_gKYr6y33K2SYeEgcDKEBlLgytRNr77rlQBc")
val WalletBackendSharedDataTooLargeException_cborSchemaId = ByteString(10, 30, 39, 54, 119, 127, -128, -90, 43, -21, 45, -9, 43, 100, -104, 120, 72, 28, 12, -95, 1, -108, -72, 50, -75, 19, 107, -17, -70, -27, 64, 23)

fun WalletBackendSharedDataTooLargeException.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "WalletBackendSharedDataTooLargeException")
    return builder.end().build()
}

fun WalletBackendSharedDataTooLargeException_fromDataItem(dataItem: DataItem): WalletBackendSharedDataTooLargeException {
    return WalletBackendSharedDataTooLargeException(
    )
}
